export const VERIFICATION_METHOD = {
  DOCUMENT: "id_document",
  TRUSTED_PROFILE: "trusted_profile_signature",
  PESEL_REGISTER: "pesel_register_document",
  BANQUP: "banqup",
  TRANSFER: "fiberpay_transfer",
};

export const DOCUMENT_METHOD_FILE_TYPES = ["id_front", "id_back", "selfie"];
